import React from 'react'

export default function Foo() {
    return (
        <div className='pt-2  pb-1' style={{ backgroundColor: "black" }}>
            <p className="text-light text-center small pe-2 px-3">
                © 2025 شبكة الصحافة والإعلام الفلسطينية. جميع الحقوق محفوظة.
            </p>
        </div>
    )
}
